/**
 * Parses the body of a "vcard" message into contact cards. The body holds one
 * or more BEGIN:VCARD blocks; older imported rows only hold the display name.
 */
export const parseVcards = (body) => {
  const text = String(body || "").trim();
  if (!text) return [];
  if (!/BEGIN:VCARD/i.test(text)) return [{ name: text, number: "" }];

  return text
    .split(/(?=BEGIN:VCARD)/i)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => {
      let name = "";
      let number = "";
      block.split(/\r?\n/).forEach((line) => {
        const sep = line.indexOf(":");
        if (sep < 0) return;
        const key = line.slice(0, sep).toUpperCase();
        const value = line.slice(sep + 1).trim();
        const field = key.replace(/^ITEM\d+\./, "").split(";")[0];
        if (field === "FN" && value) name = value;
        if (field === "N" && !name) name = value.replace(/;/g, " ").trim();
        if (field === "TEL" && !number) {
          const waid = /WAID=(\d+)/.exec(key);
          number = waid ? waid[1] : value.replace(/\D/g, "");
        }
      });
      return { name: name || number, number };
    })
    .filter((card) => card.name || card.number);
};

export default parseVcards;
